import { useMutation, useQuery } from "@tanstack/react-query";
import FileUploadService from "@/services/file-upload/file-upload.service";
import type { FileUploadDto } from "@/models/dto/file-upload.dto";

export const useFileUpload = () => {
  return useMutation({
    mutationFn: (dto: FileUploadDto) => FileUploadService.uploadFile(dto),
  });
};

export const useDownloadCertificate = (key: string) => {
  return useQuery({
    queryKey: ["download-certificate", key],
    queryFn: () => FileUploadService.downloadCertificate(key),
    enabled: !!key,
  });
};

export const useDownloadCertificateMutation = () => {
  return useMutation({
    mutationFn: (key: string) => FileUploadService.downloadCertificate(key),
  });
};
